<script>
	import { onMount } from "svelte";

	import { model } from "../../../stores";

	import AddressAutoComplete from "../../../components/AddressAutoComplete.svelte";
	import Input from "../../../components/Input.svelte";
	import Checkbox from "../../../components/Checkbox.svelte";
	import FormRow from "../../../components/FormRow.svelte";
	import FormColumn from "../../../components/FormColumn.svelte";

	export let stage = null;
	export let signature = null;
	export let dateSignature = null;
	export let consent = null;
	export let firstName = null;
	export let surname = null;

	const setDate = () => {
		const date = new Date();
		const day = (date.getDate() + "").padStart(2, "0");
		const month = (date.getMonth() + 1 + "").padStart(2, "0");
		const year = date.getFullYear();
		dateSignature = `${day}/${month}/${year}`;
	};

	onMount(() => {
		dateSignature || setDate();
	});
</script>

<div class="form-group form-row d-flex align-items-end">
	<FormColumn cols="8">
		<Input
			required
			disabled={stage === "review"}
			htmlLabel="Group Member or representative's signature<br><i>Your name ({firstName} {surname})</>"
			placeholder="Type your full name"
			bind:value={signature}
		/>
	</FormColumn>
	<FormColumn cols="4">
		<Input readonly label="Date" bind:value={dateSignature} />
	</FormColumn>
</div>

<FormRow>
	<FormColumn cols="12">
		<Checkbox
			required
			disabled={stage === "review"}
			bind:checked={consent}
			label="By completing this Online Opt Out Form you acknowledge and agree that your consent is provided by typed name in lieu of your signature"
			id="consent"
		></Checkbox>
	</FormColumn>
</FormRow>
